export enum Severity {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface Message {
  text: string;
  severity: Severity;
  href?: string;
  hrefText?: string;
  timeout?: number;
}
